import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=bc6211c0&scoped=true"
import script from "./NotificationButton.vue?vue&type=script&lang=js"
export * from "./NotificationButton.vue?vue&type=script&lang=js"
import style0 from "./NotificationButton.vue?vue&type=style&index=0&id=bc6211c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6211c0",
  null
  
)

export default component.exports